<!-- 产品报告 -->
<template>
  <BaseFormItem2
    class="report"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseCheckboxGroup2 v-model="val" @change="handleChange">
      <BaseTipPopover 
        v-for="item in options"
        :key="item.value" 
        :content="item.tips" 
        :disabled="!item.tips"
      >
        <el-checkbox 
          border
          slot="reference"
          :label="item.value"
          :class="{'hide-checkbox': item.value === '无需'}"
        >{{ item.label }}</el-checkbox>
      </BaseTipPopover>
    </BaseCheckboxGroup2>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: Array,
      default: []
    },
    // 产品类别
    board_type: {
      type: String,
      default: 'FR-4'
    },
    // 板子层数
    blayer: {
      type: Number,
      default: 2
    },
    // 阻抗
    impendance: {
      type: Number,
      default: 0
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('report')
    },
    isFpc() {
      return this.board_type == 'FPC'
    },
    options() {
      const { val, fields, impendance, isFpc } = this

      const hideOption = impendance != 1 ? '阻抗报告' : ''
      if (val.includes(hideOption)) {
        this.changeVal(val.filter(item => item != hideOption))
      }
      // FPC没有实物菲林选项
      return fields.options.filter(item => item.value != hideOption && !(isFpc && item.value == '实物菲林'))
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    blayer(blayer) {
      if (this.isFpc) return
      if (blayer < 6 && !this.val.includes('无需')) {
        this.changeVal(['无需'])
      }
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      this.$topWarning.mergeFields(this.fields.label)
      this.val = val
      this.handleEmit()
    },
    handleChange(value) {
      this.val = !value || value.length === 0 || (value.length > 1 && value.indexOf('无需') > 0) 
        ? ['无需'] 
        : value.filter(item => item !== '无需')
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
.report {
  .hide-checkbox {
    position: relative;
    margin-right: 16px !important;
    &::before {
      content: '';
      position: absolute;
      top: 5px;
      right: -14px;
      display: inline-block;
      width: 1px;
      height: 22px;
      background-color: #D1D1D1;
    }
  }
}
</style>